import FacetedSearch from 'ps-components/redux/facetedSearch';
import apiClient from 'ps-components/lib/apiClient';
import { PAGE_CODE } from '../../../../lib/pageCodeDefaults';
import { areAllFacetsUnchecked } from '../../../../lib/facetHelpers';

const nameSpace = 'BULK_PRICING';
const BULK_PRICING_SET_CURRENCY = 'BULK_PRICING_SET_CURRENCY';
const RESET_BULK_PRICING_REDUCER = 'RESET_BULK_PRICING_REDUCER';

const initialState = {
  currency: '%',
  error: null,
  exclude: {},
  facets: [],
  facetIsCheckedByDefault: false,
  facetSelection: {},
  filters: {},
  filtersAreOpen: false,
  include: {},
  items: [],
  limit: 50,
  loaded: true,
  loading: false,
  offset: 0,
  query: '',
  resetFacetText: 'Reset Filters',
  showAddButton: false,
  showZeros: false,
  sortBy: 'label'
};

const options = {
  apiClient,
  graphql: { apiClient },
  getInstanceState: store => store.marketPricing.BulkPricing.FacetPanel,
  useCMS: true,
  // eslint-disable-next-line no-unused-vars
  genericGridParams: state => {
    const { BulkPricing, MarketPricingReducer } = state.marketPricing;
    const { facetSelection, facets, query } = state.marketPricing.BulkPricing.FacetPanel;
    const anyFacetsUnselected = areAllFacetsUnchecked(facets, facetSelection);
    const showResetAllButton = !anyFacetsUnselected || (query && query !== '');

    return {
      currency: state.session.currency ? state.session.currency.code : '%',
      benchmarkYears: state.session.benchmarkYear ? [state.session.benchmarkYear] : [],
      displayIn: state.session.monetary_display,
      getDefaultDataCuts: true,
      limitSubscribedSurveys: true,
      orderBy: BulkPricing.SurveyLibrary.orderBy,
      pageCode: PAGE_CODE.BULK_PRICING_SURVEY_SEARCH,
      returnResults: !!showResetAllButton
    };
  }
};

export const surveyFacetSearch = new FacetedSearch(nameSpace, initialState, options);

function extendReducer(state, action) {
  switch (action.type) {
    case BULK_PRICING_SET_CURRENCY:
      return {
        ...state,
        currency: action.currency
      };
    case RESET_BULK_PRICING_REDUCER:
      return { ...surveyFacetSearch.getInitialStateCopy(nameSpace, initialState), currency: state.currency };
    default:
      return null;
  }
}

export default surveyFacetSearch.createReducer(extendReducer, {
  searchAPI: '/cms/api/accounts/{{masterAccountId}}/survey-jobs'
});

///////////////////////////////////
//           ACTIONS             //
///////////////////////////////////

export const bulkPricingActions = surveyFacetSearch.getActions();
export const searchInputSearch = bulkPricingActions.searchInputSearch;

bulkPricingActions.setCurrency = currency => {
  return async dispatch => {
    return dispatch({
      type: BULK_PRICING_SET_CURRENCY,
      currency: currency || '%'
    });
  };
};

bulkPricingActions.resetBulkPricingReducer = () => {
  return { type: RESET_BULK_PRICING_REDUCER };
};
